import {
    HomeFilledIcon,
    HourglassFilledIcon,
} from "@wags/ui/product-icons.tsx";
import { cn } from "@wags/ui/ui-utils";
import type { ChangedAdoptionStatus } from "./adoption-status";

const TILTS = [
    "-rotate-5",
    "rotate-3",
    "-rotate-2",
    "rotate-4",
    "-rotate-4",
    "rotate-2",
] as const;

const SIZES = {
    card: { sticker: "size-10", icon: "size-5" },
    hero: { sticker: "size-11", icon: "size-5" },
} as const;

const SKINS = {
    pending: {
        className: "bg-havanese text-chocolate-lab",
        Icon: HourglassFilledIcon,
    },
    unavailable: {
        className: "bg-chocolate-lab text-maltese-white",
        Icon: HomeFilledIcon,
    },
} as const;

function tiltFor(id: string) {
    let sum = 0;
    for (const char of id) sum += char.charCodeAt(0);
    return TILTS[sum % TILTS.length];
}

export function StatusSticker({
    id,
    status,
    size = "card",
    className,
}: {
    id: string;
    status: ChangedAdoptionStatus;
    size?: keyof typeof SIZES;
    className?: string;
}) {
    const { className: skin, Icon } = SKINS[status];
    return (
        <span
            aria-hidden="true"
            className={cn(
                "pointer-events-none grid shrink-0 place-items-center rounded-full border-2 border-true-white shadow-elevation-md",
                skin,
                SIZES[size].sticker,
                tiltFor(id),
                className,
            )}
        >
            <Icon className={SIZES[size].icon} />
        </span>
    );
}
